import { Plus } from "lucide-react";

import { withForm } from "~/components/form/app-form";
import { ArrayItemCard } from "~/components/form/fields/array-item-card";
import { Button } from "~/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const BenefitsSection = withForm({
  ...offerFormOptions,
  props: {} as { canUseOfferPage: boolean },
  render: function Render({ form, canUseOfferPage }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Benefits of this program</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.Field name="benefits" mode="array">
            {(arrayField) => (
              <>
                {(arrayField.state.value ?? []).map((item, i) => (
                  <ArrayItemCard
                    key={i}
                    index={i}
                    isFirst={i === 0}
                    isLast={i === (arrayField.state.value?.length ?? 0) - 1}
                    isDeleted={item._delete === true}
                    itemLabel="benefit"
                    onMoveUp={() => arrayField.moveValue(i, i - 1)}
                    onMoveDown={() => arrayField.moveValue(i, i + 1)}
                    onToggleDelete={() =>
                      form.setFieldValue(
                        `benefits[${i}]._delete`,
                        !item._delete,
                      )
                    }
                  >
                    <form.AppField name={`benefits[${i}].title`}>
                      {(field) => <field.TextField label="Title" required />}
                    </form.AppField>
                    {canUseOfferPage && (
                      <>
                        <form.AppField name={`benefits[${i}].content`}>
                          {(field) => (
                            <field.TextareaField
                              label="Content"
                              maxLength={500}
                            />
                          )}
                        </form.AppField>
                        <form.AppField name={`benefits[${i}].imageSrc`}>
                          {(field) => (
                            <field.ImageField
                              purpose="offer"
                              label="Image"
                              recommendedDimensions={{
                                width: 600,
                                height: 400,
                              }}
                            />
                          )}
                        </form.AppField>
                      </>
                    )}
                  </ArrayItemCard>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    arrayField.pushValue({
                      title: "",
                      content: "",
                      imageSrc: "",
                      order: arrayField.state.value?.length ?? 0,
                      _delete: false,
                    })
                  }
                >
                  <Plus className="mr-2 h-4 w-4" /> Add Benefit
                </Button>
              </>
            )}
          </form.Field>
        </CardContent>
      </Card>
    );
  },
});
